import { apiClient } from '~/api/client';
import type { components } from '~/types/api';

export type CnpjLookupResponse = components['schemas']['CnpjLookup'];
export type CepLookupResponse = components['schemas']['CepLookup'];
export type CodigoServico = components['schemas']['CodigoServico'];
export type CodigosServicoResponse = components['schemas']['CodigosServicoResponse'];

export async function lookupCnpj(cnpj: string): Promise<CnpjLookupResponse> {
  const response = await apiClient.get<CnpjLookupResponse>(`/api/invoices/lookup-cnpj/${cnpj}/`);
  return response.data;
}

/** O tomador não tem campo de tipo: "Rua" vai junto do nome, como o ViaCEP traz. */
export function streetWithType({
  tipo_logradouro,
  logradouro,
}: Pick<CnpjLookupResponse, 'tipo_logradouro' | 'logradouro'>): string {
  return [tipo_logradouro, logradouro].filter(Boolean).join(' ');
}

export async function lookupCep(cep: string): Promise<CepLookupResponse> {
  const response = await apiClient.get<CepLookupResponse>(`/api/invoices/lookup-cep/${cep}/`);
  return response.data;
}

export async function fetchCodigosServico(clientId: number): Promise<CodigosServicoResponse> {
  const response = await apiClient.get<CodigosServicoResponse>('/api/codigos-servico/', {
    params: { client: clientId },
  });
  return response.data;
}
